// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SvmL","input":"styles_input__17IKN"};